import { Component, ChangeDetectionStrategy } from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';
import {Router} from '@angular/router';
import {ITableAction} from '../../piquant-table/models';

@Component({
    selector: 'app-view-button-renderer',
    templateUrl: './view-button-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class ViewButtonRendererComponent implements AgRendererComponent {
  listener: () => void;

  public params: any;
  public name: string;
  public ngbWorkAroundLock: boolean = false;
  private actionTable: ITableAction;

  constructor(private router: Router) {

  }

  agInit(params: any): void {
    this.params = params;
    this.name = params.data.name;
    this.actionTable = this.invokeBuildActions();
  }


  public invokeBuildActions(): ITableAction {
    return this.params.context.componentParent.buildTableActions();
  }

  public refresh(params: any): boolean {
    return true;
  }
}
